import React from "react";

import { Box, Flex, Heading, Text } from "@catchoftheday/cg-components";

export type BenefitBoxProps = {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
};

export const BenefitBox: React.FC<BenefitBoxProps> = ({
  icon,
  title,
  subtitle,
}) => {
  return (
    <Box width="50%" p="8px">
      <Box
        borderRadius="16px"
        borderColor="onePass.primary"
        borderWidth="1px"
        borderStyle="solid"
        height="160px"
        color="onePass.textPrimary"
        px="12px"
      >
        <Flex alignItems="center" height="52px" color="onePass.primaryDark">
          {icon}
        </Flex>
        <Heading.h4
          lineHeight="normal"
          m="0"
          mb="4px"
          fontWeight="bold"
          fontFamily="inherit"
        >
          {title}
        </Heading.h4>
        <Text fontWeight="medium" m="0" fontSize="xs">
          {subtitle}
        </Text>
      </Box>
    </Box>
  );
};
